module.exports = __webpack_public_path__ + "static/media/chakra-ui-icon.4985d922.svg";